import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios'
import { isEmpty } from 'lodash'

type TokenProvider = () => string

export const authInterceptor = (tokenProvider: TokenProvider) => {
  return (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const accessToken = tokenProvider()

    if (!isEmpty(accessToken) && config.headers) {
      config.headers.Authorization = `Bearer ${accessToken}`
    }

    return config
  }
}

export const registerAuthInterceptor = (
  $axios: AxiosInstance,
  tokenProvider: TokenProvider
): void => {
  $axios.interceptors.request.use(authInterceptor(tokenProvider))
}
